import * as React from 'react';
import { Box, Flex, Grid, Text } from '@ttoss/ui';
import {
  Controller,
  Form,
  FormFieldInput,
  FormFieldSelect,
  useForm,
  yup,
  yupResolver,
} from '@ttoss/forms';
import { HeaderRegister } from '../HeaderRegister/HeaderRegister';
import { STATES } from 'src/constants/states';
import { UserTypesButtons } from '../UserTypesButtons/UserTypesButtons';
import { useAuth } from '@ttoss/react-auth';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useSiflorApi } from 'src/providers/SiflorApiProvider/useSiflorApi';
import Button from '../Button/Button';

const schema = yup.object().shape({
  name: yup.string().required('O campo Nome Completo é obrigatório'),
});

export const MyAccount = () => {
  const navigate = useNavigate();

  const { siflorApi } = useSiflorApi();

  const { user } = useAuth();

  const { data } = useQuery<{ user: any[] }>({
    queryKey: ['getUser', user?.id],
    queryFn: ({ queryKey }) => {
      const userId = queryKey[1];
      return siflorApi.getUser(userId);
    },
  });

  const formMethods = useForm({
    mode: 'all',
    resolver: yupResolver(schema),
  });

  const { reset, formState, setValue } = formMethods;

  const { isDirty } = formState;

  React.useEffect(() => {
    if (data?.user?.[0]) {
      const { email, name, phoneNumber, city, state } = data.user[0];
      reset({ email, name, phoneNumber, city, state });
    }
  }, [data, reset]);

  const [error, setError] = React.useState('');

  React.useEffect(() => {
    if (isDirty) {
      setError('');
    }
  }, [isDirty]);

  const handleSubmit = async (data: any) => {
    try {
      await siflorApi.updateUser(user.id, data);
      navigate('/meus-locais');
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <Flex sx={{ flexDirection: 'column' }}>
      <HeaderRegister title="Minha Conta" isBackbar />

      <Flex sx={{ flexDirection: 'column' }}>
        <Form
          sx={{
            paddingY: 9,
            paddingX: 7,
            maxWidth: '800px',
            alignSelf: 'center',
            width: '100%',
          }}
          {...formMethods}
          onSubmit={handleSubmit}
        >
          <Controller
            name="userTypeId"
            control={formMethods.control}
            render={({ field: { value } }) => {
              return (
                <UserTypesButtons
                  onUserTypeChange={(userTypeId) => {
                    setValue('userTypeId', userTypeId);
                  }}
                  userTypeId={value}
                  userTypeType={data?.user?.[0]?.userTypes?.type}
                />
              );
            }}
          />

          <Flex sx={{ flexDirection: 'column', gap: 6, marginTop: 8 }}>
            <FormFieldInput disabled name="email" label="Email*:" />
            <FormFieldInput name="name" label="Nome completo*:" />
            <FormFieldInput
              name="phoneNumber"
              label="Telefone para contato*:"
            />

            <Grid sx={{ gridTemplateColumns: '4fr 1fr', alignItems: 'end' }}>
              <FormFieldInput name="city" label="Cidade e estado*:*:" />

              <Box
                sx={{
                  'div>select': {
                    border: 0,
                    borderBottomWidth: 1,
                    borderBottomColor: 'primaryVariant',
                    borderBottomStyle: 'solid',
                    borderRadius: 0,
                    outline: 0,
                    color: 'text',
                  },
                }}
              >
                <FormFieldSelect name="state" options={STATES} />
              </Box>
            </Grid>
            {/* <FormField.Input disabled name="username" label="Login*:" /> */}
          </Flex>

          <Flex
            sx={{
              marginTop: 9,
              width: '100%',
              justifyContent: 'center',
            }}
          >
            {error && <Text sx={{ color: 'red' }}>{error}</Text>}
          </Flex>

          <Flex sx={{ flexDirection: 'column', marginTop: 9, gap: 6 }}>
            <Button
              type="button"
              color="primary"
              outlined
              onClick={() => {
                navigate('/meus-locais');
              }}
            >
              Cancelar
            </Button>

            <Button type="submit">Salvar</Button>
          </Flex>
        </Form>
      </Flex>
    </Flex>
  );
};
